<ng-template [ngIf]="fileInfo">
  <ng-container *ngIf="file$ | async as file">
    <a class="text-primary link-effect" (click)="download(file)">{{ file.title }}</a>
  </ng-container>
</ng-template>
